import React, {useState} from "react"
import {Button} from "../Components/Button"
import {InputText} from "../Components/Input"
import {Modal} from "../Components/Modal"
import {Product} from "../Views/Solution/Product"
import {useCatalog, useModal, useRoomSetup, useSolution, useLocal} from "../AppContext"
import {MODAL__SOLUTION_PRODUCT_ADD} from "../Hooks/Modal"
import {MOUNTING__CEILING, MOUNTING__DOOR, MOUNTING__FLOOR, MOUNTING__WALL, MOUNTING__WIRE_DUO40, MOUNTING__WIRE_DUO48, MOUNTING__WIRE_UNO} from "../Hooks/Catalog"
import style from "./SolutionProductAdd.css"

export const SolutionProductAdd = ({setProduct}) => {
    const local = useLocal()
    const selector = useSelector()

    return <Modal type={MODAL__SOLUTION_PRODUCT_ADD} tile={local.__("Absorber hinzufügen")} userStyle={{width: "600px"}}>
        <div className={style.layout}>
            <Mounting selector={selector}/>
            <ProductList selector={selector} setProduct={setProduct}/>
            <Footer selector={selector}/>
        </div>
    </Modal>
}

const Mounting = ({selector}) => {
    const local = useLocal()

    return <div className={style.mounting}>
        <div onClick={() => selector.addToWall()} className={selector.isToWall() ? style.active : null}>{local.__("Wand-Absorber")}</div>
        <div onClick={() => selector.addToCeiling()} className={selector.isToCeiling() ? style.active : null}>{local.__("Decken-Absorber")}</div>
        <div onClick={() => selector.addToFloor()} className={selector.isToFloor() ? style.active : null}>{local.__("Boden-Absorber")}</div>
    </div>
}

const ProductList = ({selector, setProduct}) => {
    const catalog = useCatalog()
    const local = useLocal()
    const roomSetup = useRoomSetup()
    const [search, setSearch] = useState("")
    const products = catalog.getList(
        selector.getMountingSurfaces(),
        roomSetup.getRoomHeight(),
        roomSetup.getCeilingConstitution(),
        roomSetup.getWallConstitution(),
        search
    )

    const onSelect = (product) => {
        selector.setProduct(product)
    }

    const isCurrent = (product) => {
        return product.sku === selector.getProduct()?.sku
    }

    return <div className={style.list}>
        <div className={style.search}>
            <InputText calue={search} onChange={event => setSearch(event.target.value)} placeholder={local.__("Suche")}/>
        </div>
        {products.map((product, index) => <Product key={index} product={product} setProduct={setProduct} isCurrent={isCurrent(product)} onSelect={onSelect} selector={selector}/>)}
    </div>
}


const Footer = ({selector}) => {
    const local = useLocal()
    const solution = useSolution()
    const modal = useModal()

    const apply = async () => {
        const status = await solution.addItem(selector.getProduct(), selector.getMountingSurfaces())

        if (status) {
            modal.close()
        }
    }

    return <div className={style.footer}>
        <Button onClick={apply} isDisabled={!selector.getProduct()}>{local.__("Absorber hinzufügen")}</Button>
    </div>
}

const useSelector = () => {
    const [type, setType] = useState(MOUNTING__WALL)
    const [product, setProductState] = useState(null)

    const getType = () => {
        return type
    }

    const isOpen = () => {
        return type !== null
    }

    const close = () => {
        return setType(null)
    }

    const getMountingSurfaces = () => {
        if (isToCeiling()) return [MOUNTING__CEILING, MOUNTING__WIRE_UNO, MOUNTING__WIRE_DUO40, MOUNTING__WIRE_DUO48]
        if (isToWall()) return [MOUNTING__WALL]
        if (isToFloor()) return [MOUNTING__FLOOR]
        if (isToDoor()) return [MOUNTING__DOOR]
        return []
    }
    const isToCeiling = () => {
        return type === MOUNTING__CEILING
    }

    const addToCeiling = () => {
        if (!isToCeiling()) {
            setType(MOUNTING__CEILING)
            setProductState(null)
        }
    }

    const isToWall = () => {
        return type === MOUNTING__WALL
    }

    const addToWall = () => {
        if (!isToWall()) {
            setType(MOUNTING__WALL)
            setProductState(null)
        }
    }

    const isToFloor = () => {
        return type === MOUNTING__FLOOR
    }

    const addToFloor = () => {
        if (!isToFloor()) {
            setType(MOUNTING__FLOOR)
            setProductState(null)
        }
    }

    const isToDoor = () => {
        return type === MOUNTING__DOOR
    }

    const addToDoor = () => {
        if (!isToDoor()) {
            setType(MOUNTING__DOOR)
            setProductState(null)
        }
    }

    const setProduct = (product) => {
        setProductState(product)
    }
    const getProduct = () => {
        return product
    }

    return {
        getType,
        isOpen, close, getMountingSurfaces,
        isToCeiling, addToCeiling,
        isToWall, addToWall,
        isToFloor, addToFloor,
        isToDoor, addToDoor,
        setProduct, getProduct
    }
}